module.exports = __webpack_public_path__ + "static/forge-ecfa2cb58e2c03a3f401d00fbf58c8bb.svg";